// 当前账号

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import { KAccount } from '../../../models/k-user'

function getInitAccount () {
    const _wzAccount_ = window._wzAccount_
    return _wzAccount_ ? KAccount(_wzAccount_) : null
}

// console.log(getInitAccount());

const state = {
    info: getInitAccount(), // 当前登录账号信息
    teacher: null  // 老师信息
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
